// @ts-nocheck

import React, { useState, useCallback, useMemo } from 'react';
import type { Node } from 'react';
import styled, { css } from 'styled-components';

import { LightArrow } from '../../assets/svg';
import { type ScorersType } from '../../states/scoreboards';
import theme from '../../styled-components/dark';
import ScoreboardScorerItem from '../ScoreboardScorerItem';

const Footer = styled.div`
  position: relative;
  display: flex;
  justify-content: space-between;
  user-select: none;
  ${({ $clickable }) =>
    $clickable
      ? css`
          cursor: pointer;
        `
      : undefined}
  background: ${theme.Scoreboards.wrapperBackground};
`;
const ScorersList = styled.div`
  flex: 1 1 6.25em;
  min-width: 0;
  color: ${theme.Scoreboards.color};
  ${({ $align }) => css`
    text-align: ${$align};
  `};
`;

const iconStyles = css`
  width: 1em;
  height: 1em;
  color: ${theme.Scoreboards.color};
  flex-shrink: 0;
  align-self: flex-end;
  margin-bottom: -0.6em;
`;

const ArrowUp = styled(LightArrow)`
  ${iconStyles}
  transform: rotate(90deg);
`;
const ArrowDown = styled(LightArrow)`
  ${iconStyles}
  transform: rotate(-90deg);
`;

type ScoreboardScorersProps = {
  sportId?: number;
  scorersCompetitor1?: ScorersType;
  scorersCompetitor2?: ScorersType;
  expandThreshold?: number;
};

const ScoreboardScorers = ({
  sportId,
  scorersCompetitor1,
  scorersCompetitor2,
  expandThreshold = 1,
}: ScoreboardScorersProps): Node => {
  const [isExpanded, setIsExpanded] = useState(false);
  const Icon = isExpanded ? ArrowUp : ArrowDown;

  const shouldAllowExpand =
    (scorersCompetitor1 || []).length > expandThreshold || (scorersCompetitor2 || []).length > expandThreshold;

  const competitor1TimePadding = useMemo(
    () => scorersCompetitor1?.some((scorer) => (scorer.time?.length ?? 0) > 4) ?? false,
    [scorersCompetitor1],
  );
  const competitor2TimePadding = useMemo(
    () => scorersCompetitor2?.some((scorer) => (scorer.time?.length ?? 0) > 4) ?? false,
    [scorersCompetitor2],
  );

  const toggleScorers = useCallback(() => {
    if (shouldAllowExpand) {
      setIsExpanded((prev) => !prev);
    }
  }, [shouldAllowExpand]);

  return (
    <Footer onClick={toggleScorers} $clickable={!!shouldAllowExpand}>
      <ScorersList align="left">
        {scorersCompetitor1
          ?.slice(0, isExpanded ? scorersCompetitor1?.length : expandThreshold)
          .map((scorer, index) => (
            <ScoreboardScorerItem
              sportId={sportId}
              key={index}
              scorer={scorer}
              invert
              padding={competitor1TimePadding}
            />
          ))}
      </ScorersList>
      {shouldAllowExpand ? <Icon /> : null}
      <ScorersList $align="right">
        {scorersCompetitor2
          ?.slice(0, isExpanded ? scorersCompetitor2?.length : expandThreshold)
          .map((scorer, index) => (
            <ScoreboardScorerItem sportId={sportId} key={index} scorer={scorer} padding={competitor2TimePadding} />
          ))}
      </ScorersList>
    </Footer>
  );
};

export default ScoreboardScorers;
